module.exports = __webpack_public_path__ + "static/media/loanrepayment.4d08f21d.png";